export default "__VITE_ASSET__B7eZoLgR__"